<template>
  <b-modal
    id="CampaignChangesModal"
    title="Would you like to apply the following changes?"
    :hide-header-close="true"
    :no-close-on-esc="true"
    centered
  >
    <p
      v-if="orderChanges.hasOwnProperty('budget')"
    >
      Changes to Budget are subject to APPROVAL
    </p>
    <b-table
      :items="newValues"
      :fields="fields"
    >
      <template v-slot:table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
        >
      </template>
      <template v-slot:cell(property)="data">
        {{ getFormattedProperty(data.item.property) }}
      </template>
      <template v-slot:cell(initialValue)="data">
        {{ data.item.initialValue }}
      </template>
      <template v-slot:cell(newValue)="data">
        {{ data.item.newValue }}
      </template>
    </b-table>
    <template #modal-footer>
      <b-button
        variant="tertiary"
        @click="discardChanges()"
      >
        Discard Changes
      </b-button>
      <div
        class="ml-auto"
      >
        <b-button
          variant="secondary"
          @click="continueEditing()"
        >
          Continue Editing
        </b-button>
        <b-button
          class="ml-2"
          variant="primary"
          @click="applyChanges()"
          :class="{ 'btn-loading': isApplyChangesButtonLoading }"
        >
          Apply Changes
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import _ from 'lodash';

export default {
  name: 'CampaignChangesModal',
  props: {
    isApplyChangesButtonLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isApplyingChanges: false,
      fields: [
        { key: 'property', label: 'Property' },
        { key: 'initialValue', label: 'Initial Value' },
        { key: 'newValue', label: 'New Value' },
      ],
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
      'campaignChanges',
      'order',
      'orderChanges',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_CAMPAIGN_TOTAL_BUDGET,
    ]),
    newValues() {
      if (!this.order.hasOwnProperty('budget') || !this.orderChanges.hasOwnProperty('periods')) return [];
      return [{
        property: 'Total Budget',
        initialValue: this.order.budget,
        newValue: this.GET_CAMPAIGN_TOTAL_BUDGET,
      }];
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.SET_CAMPAIGN_INFO_CHANGES,
    ]),
    getFormattedProperty(property) {
      return _.startCase(property);
    },
    closeModal() {
      this.$bvModal.hide('CampaignChangesModal');
    },
    discardChanges() {
      this.$emit('discardChanges');
      this.SET_CAMPAIGN_INFO_CHANGES({});
      this.closeModal();
    },
    continueEditing() {
      this.$emit('continueEditing');
      this.closeModal();
    },
    applyChanges() {
      this.$emit('applyChanges');
      if (!this.isApplyChangesButtonLoading) this.closeModal();
    },
  },
};
</script>
